<div class="mb-3" *ngIf="auth.isLogin()">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let link of links"><a class="text-primary" routerLink="{{link.url}}" *ngIf="!link.isFinal">{{link.name}}</a>
          <span *ngIf="link.isFinal">{{link.name}}</span>
        </li>
      </ol>
    </nav>
  </div>
